export enum LocalstorageKeys {
    CART_ITEMS = 'cartItems',
    USER_INFO = 'userInfo',
    SHIPPING_ADDRESS = 'shippingAddress',
    PAYMENT_METHOD = 'paymentMethod',
}
